import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback } from 'react';
import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { set_ui_settings } from '../../../redux/settings-actions';
import { useAction } from 'shared/hooks/redux/hooks';
export const FilterTree = memo(function FilterTree(props) {
    const { event_filter, event_filter_groups } = props;
    const setUiSettings = useAction(set_ui_settings);
    const applyCheckboxes = useCallback((eventKind, checked) => {
        const newFilter = Object.fromEntries(eventKind.map((kind) => [kind, checked]));
        setUiSettings({ event_filter: newFilter });
    }, [setUiSettings]);
    return (_jsx(Box, { sx: {
            '& .MuiFormGroup-root': {
                pl: 3,
            },
        }, children: event_filter_groups.map(({ children, id, title }) => {
            const all_group_ids = children.map((el) => el.id);
            const hasChecked = all_group_ids.some((id) => event_filter[id]);
            const hasUnchecked = all_group_ids.some((id) => !event_filter[id]);
            return (_jsx(React.Fragment, { children: _jsxs(Box, { py: 1, px: 2, children: [_jsx(FormControlLabel, { label: title, control: _jsx(Checkbox, { color: "primary", checked: !hasUnchecked, indeterminate: hasChecked && hasUnchecked, onChange: () => applyCheckboxes(all_group_ids, hasUnchecked) }) }), _jsx(FormGroup, { children: children.map((el) => {
                                return (_jsx(FormControlLabel, { label: el.title, control: _jsx(Checkbox, { color: "primary", checked: event_filter[el.id] !== false, onChange: (_, checked) => applyCheckboxes([el.id], checked) }) }, el.id));
                            }) })] }) }, id));
        }) }));
});
